import { getCountryFromCountryCodeOrName } from "country-codes-flags-phone-codes";

export const getCountriesOptions = (countries) => {
  return ((Array.isArray(countries) && countries) || []).map(
    ({ name, code }) => ({
      label:
        (
          getCountryFromCountryCodeOrName(code) ||
          getCountryFromCountryCodeOrName("US")
        )?.flag +
        " " +
        name,
      value: name,
    })
  );
};
